export const dateFormat = 'yyyy-MM-dd';
export const timeFormat = 'HH:mm';
export const dateTimeFormat = `${dateFormat}, ${timeFormat}`;
